import { useSelector } from "react-redux";
import { selGrants, selAirlineBaseModules, selSecret } from "store/slices";
export const TAKEOFF_PATH = "/app/dashboard/performance/takeoff";
export const SUBMISSIONS_PATH = "/app/dashboard/performance/submissions";
export function performanceAccess(modules, grants, now = new Date()) {
  const active = modules?.some(
    (item) =>
      item.module === "enr:performance:module" &&
      item.enabled &&
      item.expiration_date &&
      new Date(item.expiration_date) > now
  );
  const parent = grants?.module?.performance;
  const leaf = parent?.menu?.takeoff;
  const submissionsLeaf = parent?.menu?.submissions;
  const moduleShown =
    active && ["show", "view", "edit"].includes(parent?.action);
  const visible = moduleShown && ["view", "edit"].includes(leaf?.action);
  const submissionsVisible =
    moduleShown && ["view", "edit"].includes(submissionsLeaf?.action);
  return {
    canView: Boolean(visible),
    canCalculate: Boolean(visible && leaf.action === "edit"),
    // The Final Submits of the EFB (Performance > Submissions).
    canViewSubmissions: Boolean(submissionsVisible),
    // The Performance menu is shown when any of its pages is.
    canViewMenu: Boolean(visible || submissionsVisible),
  };
}
export function usePerformanceAccess() {
  const modules = useSelector(selAirlineBaseModules);
  const grants = useSelector(selGrants);
  const secret = useSelector(selSecret);
  return { ...performanceAccess(modules, grants), secret };
}
